import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getOrderGeneratorsFieldsWorksQualityControls(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		options
	)
}

function _getOrderGeneratorsFieldsWorksQualityControl(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
		options
	)
}

function _createOrderGeneratorsFieldsWorksQualityControl(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
		options
	)
}

function _putOrderGeneratorsFieldsWorksQualityControl(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PUT_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
		options
	)
}

function _patchOrderGeneratorsFieldsWorksQualityControl(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
		options
	)
}

function _deleteOrderGeneratorsFieldsWorksQualityControl(options={}) {
	return _apiRequestWrap(
		ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS,
		ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS]: _getOrderGeneratorsFieldsWorksQualityControls,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].GET_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: _getOrderGeneratorsFieldsWorksQualityControl,

	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].CREATE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: _createOrderGeneratorsFieldsWorksQualityControl,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PUT_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: _putOrderGeneratorsFieldsWorksQualityControl,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].PATCH_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: _patchOrderGeneratorsFieldsWorksQualityControl,
	[ModulesConfigMap[ModulesMap.ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROLS].DELETE_ORDER_GENERATORS_FIELDS_WORKS_QUALITY_CONTROL]: _deleteOrderGeneratorsFieldsWorksQualityControl,
}